<template>
  <div class="main">
    <TabListCon :divType="divTypes"></TabListCon>
    <img src="../../static/imgs/lxwm.jpg" class="img" />
    <!-- <div class="titleText">
      <div class="title">关于铭安</div>
      <div class="textMs">关于铭安关于铭安关于铭安关于铭安关于铭安关于铭安关于铭安</div>
    </div> -->
    <div class="box">
      <img src="../../static/imgs/lxwm2.jpg" class="lxwmImg" />
      <!-- <div class="titleName">铭安优势</div>
      <div class="ourInMain">
        <div class="ourInformationList">
          <div class="iconText">
            <img src="../../static/imgs/phone.png" class="iconImg" />
            <div class="msCont">
              <div class="text">服务热线</div>
              <div class="cont">400-003-9133</div>
            </div>
          </div>
          <div class="iconText">
            <img src="../../static/imgs/email.png" class="iconImg" />
            <div class="msCont">
              <div class="text">公司邮箱</div>
              <div class="cont">service@macjhome.com</div>
            </div>
          </div>
          <div class="iconText">
            <img src="../../static/imgs/phone.png" class="iconImg" />
            <div class="msCont">
              <div class="text">公司地址</div>
              <div class="cont">杭州市临平区南苑街道迎宾路IFC互联网+金融中心1幢6-7楼</div>
            </div>
          </div>
        </div>
        <div class="erCodeText">
          <div class="text">欢迎关注铭安微信公众号</div>
          <img src="../../static/imgs/erw.png" class="codeImg" />
        </div>
      </div> -->
      <!-- <div id="mapContent" class="map"></div> -->
      <img src="../../static/imgs/map.png" class="map" />
      <!-- <div class="titleName">合伙人加盟</div>
      <div class="submitMaterialsLsit">
        <div class="materialsMain">
          <div class="materialsName">选择业务类型<span class="icon">*</span> </div>

          <select name="interest" placeholder="请输入" class="select">
            <option value="" disabled selected>请输入</option>
            <option value="0">写作</option>
            <option value="2">游戏</option>
            <option value="3">音乐</option>
            <option value="4">旅行</option>
          </select>
          <img src="../../static/imgs/bom.png" class="selectImg" />
        </div>
        <div class="materialsMain">
          <div class="materialsName">姓名<span class="icon">*</span> </div>
          <input placeholder="请输入" class="inp" v-model="submitMaterialsData.name" />
        </div>
        <div class="materialsMain">
          <div class="materialsName">联系方式<span class="icon">*</span> </div>
          <input placeholder="请输入" class="inp" v-model="submitMaterialsData.phone" />
        </div>
        <div class="materialsMain">
          <div class="materialsName">业务区域<span class="icon">*</span> </div>
          <input placeholder="请输入" class="inp" v-model="submitMaterialsData.serviceArea" />
        </div>
      </div> -->
    </div>
    <!-- <div class="actionBtn" @click="handleSubmit">提交</div>
    <div class="helpText">我们将在1个工作日内与您取得联系，如需帮助请拨打400-003-9133</div> -->
    <BottomContentCon></BottomContentCon>
  </div>
</template>
<script>
import TabListCon from "../../components/TabList/index.vue"
import BottomContentCon from "../../components/BottomContent/index.vue"
import { ImagePreview } from 'vant';

export default {
  name: "Home",
  data() {
    return {
      submitMaterialsData: [{ phone: '' }, { name: '' }, { businessType: '' }, { serviceArea: '' }],
      divTypes: '5',//顶部Tab组件的index值

    }
  },
  components: { TabListCon, BottomContentCon },
  created() {

  },
  mounted() {
    this.initMap()
  },
  methods: {
    //提交信息表单
    handleSubmit() {
      console.log(this.submitMaterialsData.phone)
      if (!this.submitMaterialsData.phone) {
        this.$toast({
          message: '请填写您的联系方式...'
        });
        return
      } else if (!this.submitMaterialsData.name) {
        this.$toast({
          message: '请填写您的姓名...'
        });
      } else if (!this.submitMaterialsData.businessType) {
        this.$toast({
          message: '请填写您的业务类型...'
        });
      } else if (!this.submitMaterialsData.serviceArea) {
        this.$toast({
          message: '请填写您的业务区域...'
        });
      } else {
        //接口
      }
    },
    initMap() {
      // 创建地图实例
      const map = new AMap.Map('mapContent', {
        zoom: '12', // 缩放级别
        center: [116.397428, 39.90923] // 公司地址静态经纬度 赋值就行
      });
      // 创建一个 icon
      var endIcon = new AMap.Icon({
        size: new AMap.Size(25, 34), //图标大小
        image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png', //可以更换定位表示的图片
        imageSize: new AMap.Size(135, 40),//图标大小
        imageOffset: new AMap.Pixel(-95, -3) //图标精确贡茶
      });
      // 创建标记
      const marker = new AMap.Marker({
        map: map,
        icon: endIcon,
        position: [116.397428, 39.90923] // 位置坐标
      });
      // 将标记添加到地图
      marker.setMap(map);
    }
  }
};
</script>

<style scoped>
.map {
  width: 100%;
  margin-bottom: 24px;
}

.lxwmImg {
  width: 100%;
}

.helpText {
  text-align: center;
  margin-top: 32px;
  margin-bottom: 108px;
  color: #6D6D6D;
  font-size: 32px;
}

.actionBtn {
  height: 85px;
  background: #114035;
  border-radius: 5px 5px 5px 5px;
  text-align: center;
  line-height: 85px;
  color: #fff;
  font-size: 24px;
  width: 688px;
  margin: 108px auto 0 auto;
}

.icon {
  color: red;
  margin-left: 8px;
}

.materialsMain {
  margin-bottom: 48px;
}

.inp {
  border: none;
  width: 100%;
  height: 72px;
  font-size: 28px;
  border-radius: 8px;
  color: #BCBEC7;
  font-weight: bold;
  margin-left: 8px;
  padding: 0 32px;
  background: #F4F4F4;
}

.inp::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #BCBEC7;
}

.inp:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #BCBEC7;
}

.inp::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #BCBEC7;
}

.inp:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #BCBEC7;
}

.materialsName {
  font-size: 32px;
  color: #000000;
  font-weight: bold;
  margin-bottom: 24px;
}

.selectImg {
  width: 24px;
  height: 24px;
  position: relative;
  margin-left: -32px;
}

.select {
  border: none;
  width: 100%;
  height: 56px;
  font-size: 28px;
  border-radius: 8px;
  color: #BCBEC7;
  font-weight: bold;
  margin-left: 8px;
  padding: 0 32px;
  background: #F4F4F4;
  font-weight: bold;
}

select {
  /*Chrome和Firefox里面的边框是不一样的，所以复写了一下*/
  border: solid 1px #000;

  /*很关键：将默认的select选择框样式清除*/
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background: #F4F4F4;
  /*为下拉小箭头留出一点位置，避免被文字覆盖*/
  padding-right: 14px;
}


/*清除ie的默认选择框样式清除，隐藏下拉箭头*/
select::-ms-expand {
  display: none;
  background: #F4F4F4;

}

.map {
  width: 100%;
  height: 740px;
  margin-bottom: 160px;
}

.ourInMain {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.iconText {
  display: flex;
  align-items: center;
  margin-bottom: 64px;
}

.msCont {
  width: 1000px;
  margin-left: 40px;
}

.cont {
  font-weight: bold;
  font-size: 28px;
  color: #333333;
  line-height: 60px;
}

.erCodeText {
  margin-left: 40px;
}

.text {
  font-size: 20px;
  color: #333333;
}

.iconImg {
  width: 84px;
  height: 84px;
  display: block;
}

.erCodeText {
  width: 268px;
  height: 268px;
  text-align: center;
}

.codeImg {
  width: 268px;
  height: 268px;
}

.text {
  color: #979595;
  font-size: 24px;
  line-height: 36px;

}

.titleName {
  color: #333;
  font-size: 64px;
  text-align: center;
  font-weight: bold;
  margin-bottom: 88px;
}


.textMs {
  color: rgba(255, 255, 255, 0.8);
  font-size: 40px;
}

.title {
  color: #fff;
  font-size: 80px;
}

.titleText {
  padding: 145px;
  width: 1500px;
  margin-top: -550px;
}

.box {
  padding: 160px 120px 0 120px;
}

.img {
  width: 100%;
  height: 693px;
}
</style>